import script from "./CommmonRadioGroup.vue?vue&type=script&lang=ts&setup=true"
export * from "./CommmonRadioGroup.vue?vue&type=script&lang=ts&setup=true"

import "./CommmonRadioGroup.vue?vue&type=style&index=0&id=161e8440&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-161e8440"]])

export default __exports__